import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { FAQCard } from './FAQCard';

/**
 * FAQList - List of FAQ items in cream/beige style with modal popup
 * When clicked, opens FAQCard modal with answer
 */
export const FAQList = ({ 
  items, 
  showRelatedInModal = true,
  maxRelated = 6,
  variant = 'default' // 'default' | 'compact' | 'minimal'
}) => {
  const [selectedFAQ, setSelectedFAQ] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleSelectQuestion = (faq, index) => {
    setSelectedFAQ(faq);
    setSelectedIndex(index);
  };

  const handleCloseModal = () => {
    setSelectedFAQ(null);
    setSelectedIndex(null);
  };

  const getRelatedQuestions = (currentIndex) => {
    if (!showRelatedInModal) return [];
    return items
      .filter((_, idx) => idx !== currentIndex)
      .slice(0, maxRelated);
  };

  if (!items || items.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400" data-testid="faq-list-empty">
        No FAQs available
      </div>
    );
  }

  const variantStyles = {
    default: 'px-5 py-4 bg-amber-50 hover:bg-amber-100',
    compact: 'px-4 py-3 bg-gray-50 hover:bg-gray-100',
    minimal: 'px-4 py-3 bg-transparent hover:bg-gray-50 border-b border-gray-100'
  };

  return (
    <>
      <div className="space-y-2" data-testid="faq-list">
        {items.map((faq, index) => (
          <button
            key={faq.id || index}
            onClick={() => handleSelectQuestion(faq, index)}
            className={`w-full flex items-center justify-between rounded-lg transition-all text-left group ${variantStyles[variant]}`}
            data-testid={`faq-list-item-${index}`}
          >
            <span className="text-gray-700 pr-4 leading-relaxed">{faq.question}</span>
            <ArrowRight 
              className="text-amber-500 flex-shrink-0 group-hover:translate-x-1 transition-transform" 
              size={18} 
            />
          </button>
        ))}
      </div>

      {/* FAQ Modal */}
      {selectedFAQ && (
        <FAQCard
          question={selectedFAQ.question}
          answer={selectedFAQ.answer}
          isModal={true}
          onClose={handleCloseModal}
          showRelated={showRelatedInModal}
          relatedQuestions={getRelatedQuestions(selectedIndex)}
          onSelectQuestion={(faq) => {
            const newIndex = items.findIndex(item => item.id === faq.id || item.question === faq.question);
            handleSelectQuestion(faq, newIndex);
          }}
        />
      )}
    </>
  );
};

export default FAQList;
